import { useTranslation } from "react-i18next";
import { ConfirmDialogConfig, SecuredConfirmDialog } from "./secured-confirm-dialog";

interface Props {
  open: boolean;
  onClose: (conirmed: boolean) => void;
  overwrite: ConfirmDialogConfig;
}

export const SecuredDeleteDialog = ({ overwrite, open, onClose }: Props) => {
  const { t } = useTranslation(["dialogs", "validation"]);

  return (
    <SecuredConfirmDialog
      onClose={onClose}
      open={open}
      overwrite={{
        confirmButtonColor: "error",
        confirmationCode: overwrite?.confirmationCode ?? t("dialogs.secured.delete.dialog.form.confirm.text.field.placeholer"),
        ...overwrite,
      }}
    />
  );
};
